import React, {Component} from 'react';
import _ from 'lodash';
import Layout from 'layout/AdminLayout';
import SubHeader from 'components/AfterAuth/SubHeader';
import adminService from 'services/admin';
import AuthContext from 'context/AuthContext';
import ReactPaginate from 'react-paginate';
import constants from 'data/constants';
import modalConfig from 'modals/modalConfig';
import RootContext from 'context/RootContext';
import ReviewStatus from './ReviewStatus';
import helper from 'data/helper';
import './Providers.css';
import images from 'data/images';
import selectOptions from 'data/selectOptions';
import Select from 'components/FormControls/Select';
import ViewDocumentFile from '../JoinUs/viewDocumentFile';
import moment from 'moment';
import config from 'config/config';
import {StripeInactivateProvider} from '../../../components/AfterAuth/Settings/ProvidersTab/ProviderItem/StripeInactivateProvider';
import {RemoveStripeSubscription} from '../../../components/AfterAuth/Settings/ProvidersTab/ProviderItem/RemoveStripeSubscription';
import { DeleteConform } from '../Practices/EditPracticeRegistration/DeleteConform';
import ProfileSpecialtyTitles from 'components/AfterAuth/Dashboard/ProfileSpecialtyTitles';
const initialState = {
  list: [],
  activePage: 1,
  totalPage: 0,
  searchText: '',
  sortBy: 'practiceName',
  orderBy: 'asc',
  isEditProvider: false,
  editProviderId: '',
  editUserId: '',
  searchStatus: 'onboardeduser',
  searchUserType: 'all',
  totalRecord: 0,
};
const {confirmModalData, errorModalData, blankModalData,successModalData} = modalConfig.modalFunctions;
const {getProviderSuffix} = helper;
const {DefaultDebounceMSec} = constants;
const {getProviderList, updateUserStatus, getRequestCounts,createBirdEyeAccount} = adminService;

class ActiveProviders extends Component {
  static contextType = AuthContext;
  context = null;
  authContext=null;
  state = {...initialState};

  componentDidMount() {
    if (this.props.name && this.props.name === 'Inactive Providers') {
      this.setState({searchStatus: 'inActive'}, () => {
        this.getProviderData(true, false);
      });
    } else this.getProviderData(true, false);
  }

  componentWillMount = () => {
    this.props.history.replace({state: {...initialState}});
  };

  getSearchPractice = async () => {
    const query = new URLSearchParams(this.props.location.search);
    const searchPractice = query.get('practice', '');
    if (searchPractice) {
      this.setState({searchText: searchPractice, searchUserType: 'provider'});
    }
  };
   deleteBirdEyeAccount = async (id,Active) => {
    let aditionalInfo = await DeleteConform({
      context:  this.context,
      text: `Are you sure, you want to ${Active} this account?`,
    });
    if (!aditionalInfo) return false;
   
    let response = await createBirdEyeAccount(id, ).catch(this.handleError);
    if (response) {
      const {setGlobal} = this.context;
      let {message}=response
      setGlobal(
        'modal',
        successModalData(message, {
          callBackOnClose: () => {
            if (this.props.name && this.props.name === 'Inactive Providers') {
              this.setState({searchStatus: 'inActive'}, () => {
                this.getProviderData(true, false);
              });
            } else this.getProviderData(true, false);
          },
        }),
      );
    }
  };
   openCustomSpecialityModal = (provider) => {
    const {setGlobal} = this.context;
    const providerName=`${provider.firstName} ${provider.lastName}`;
    const specialties=_.get(provider, 'specialties', [])
    const providerId=_.get(provider, 'provideId', '')
    const customSpecialty=_.get(provider,'customSpecialty',null)
      setGlobal(
        'modal',
        blankModalData({
          CustomComponent: ProfileSpecialtyTitles,
          modalWrapperClass: 'mega-modal',
          customComponentProps: {
            data: {
              providerId,
              providerName,
              specialties,
              customSpecialty
            },
            getProviderData:()=>{this.getProviderData(true,false)} 
          },
          callBackOnClose: () => {
           
            //refetchAppointmentEvents(appointmentId, 'modal');
          },
        }),
      );
    
  };
  getProviderData = async (isCheckSearch, noLoad = false) => {
    const {location} = this.props;
    const isBackLink = _.get(location, 'state.isBackLink', false);
    if (isBackLink) {
      this.getSearchedData(location);
    } else {
      await this.getSearchPractice();
      const {
        activePage,
        searchText,
        sortBy: sort,
        orderBy: order,
        searchStatus: status,
        searchUserType,
      } = this.state;
      const response = await getProviderList(
        {
          search: searchText,
          page: activePage,
          limit: 10,
          sortBy: sort,
          orderBy: order,
          status: status,
          userType: 'provider', // searchUserType === 'all' ? null : searchUserType,
        },
        noLoad,
      ).catch(this.handleError);
      if (response) {
        const {data} = response;
        this.setState({
          list: data.list,
          totalPage: data.totalPage,
          totalRecord: _.get(data, 'totalRecord', 0),
        });
      }
    }
  };
  updateContextData = async () => {
    const requestCountData = await getRequestCounts().catch(() => null);
    if (requestCountData && requestCountData.data) {
      const {setAdminRequestCountState} = this.authContext;
      setAdminRequestCountState(prevState => {
        return {
          ...prevState,
          requestCount: {
            ...requestCountData.data,
          },
        };
      });
    }
  };
  getSearchedData = location => {
    const searchData = _.get(location, 'state', {
      activePage: 1,
      searchText: '',
      sortBy: 'practiceName',
      orderBy: 'asc',
      searchStatus: 'all',
      totalRecord: 0,
    });
    const {
      activePage,
      searchText,
      sortBy: sort,
      orderBy: order,
      searchStatus: status,
      list,
      totalPage,
      totalRecord,
    } = searchData;
    this.setState({
      list: list,
      totalPage: totalPage,
      activePage: activePage,
      searchText: searchText,
      sortBy: sort,
      orderBy: order,
      searchStatus: status,
      totalRecord: totalRecord,
    });
  };

  handleError = error => {
    const {setGlobal} = this.context;
    const {message} = error;
    setGlobal('modal', errorModalData(message));
    return null;
  };
  handlePageChange = data => {
    this.setState({activePage: data.selected + 1}, this.getProviderData);
  };
  handleChange = event => {
    this.setState({activePage: 1, searchText: event.target.value});
    if (!this.debouncedFn) {
      this.debouncedFn = _.debounce(() => {
        this.getProviderData();
      }, DefaultDebounceMSec);
    }
    this.debouncedFn();
  };
  handleSearch = () => {
    this.setState({activePage: 1}, this.getProviderData);
  };
  handleClearSearch = () => {
    this.setState({activePage: 1, searchText: ''}, this.getProviderData);
  };

  viewReviewStatus = (name, id) => {
    const {setGlobal} = this.context;
    setGlobal(
      'modal',
      blankModalData({
        CustomComponent: ReviewStatus,
        customComponentProps: {name, id},
      }),
    );
  };

  handleSortingChange = e => {
    e.preventDefault();
    const {sortBy, orderBy} = this.state;
    const {dataset} = e.target;
    const key = _.get(dataset, 'key', 'name');
    if (sortBy === key) {
      this.setState(
        {orderBy: orderBy === 'asc' ? 'desc' : 'asc', activePage: 1},
        this.getProviderData,
      );
    } else {
      this.setState({orderBy: 'asc', sortBy: key, activePage: 1}, this.getProviderData);
    }
  };

  renderShortIcon = key => {
    const {sortBy, orderBy} = this.state;
    if (key === sortBy) {
      if (orderBy === 'asc') {
        return (
          <span data-key={key} className={'sort-icon'}>
            <img data-key={key} src={images.arrowUpFilledTriangle} alt="arrowUpFilledTriangle" />
          </span>
        );
      } else {
        return (
          <span data-key={key} className={'sort-icon'}>
            <img data-key={key} src={images.arrowDownFilledTriangle} alt="arrowDownFilledTriangle" />
          </span>
        );
      }
    }
    return '';
  };

  ShowEditProvider = (providerId, userId) => {
    this.setState({isEditProvider: true, editProviderId: providerId, editUserId: userId});
    const params = new URLSearchParams();
    if (providerId) {
      params.append('provider', providerId);
    }
    if (userId) {
      params.append('user', userId);
    }
    this.props.history.push({
      pathname: '/admin/providerDetails',
      search: `?${params.toString()}`,
      state: {...this.state, isBackLink: true},
    });
  };

  ShowProviderReviews = (providerId, userId,birdEyeBusinessId) => {
    // if(!birdEyeBusinessId){
    //   this.handleError({message:"The bird eye account is not created. Please activate the bird eye account."})
    //   return
    // }
    this.setState({isEditProvider: true, editProviderId: providerId, editUserId: userId});
    const params = new URLSearchParams();
    if (providerId) {
      params.append('provider', providerId);
    }
    if (userId) {
      params.append('user', userId);
    }
    this.props.history.push({
      pathname: '/admin/provider-reviews',
      search: `?${params.toString()}`,
      state: {...this.state, isBackLink: true},
    });
  };

  handleStatusChange = event => {
    this.setState({searchStatus: event.target.value, activePage: 1}, this.getProviderData);
  };

  handleUserTypeChange = event => {
    this.setState({searchUserType: event.target.value, activePage: 1}, this.getProviderData);
  };

  confirmUpdateStatus = async(userId, currentStatus, firstName, lastName,stripeSubscription=undefined) => {
    const newStatus = currentStatus === 1 ? 0 : 1;
    const statusTitle = currentStatus === 1 ? 'deactivate' : 'activate';
    const {setGlobal} = this.context;
    if (config.showStripe === true&&stripeSubscription) {
      let removeProv = await StripeInactivateProvider({context: this.context});
      if (removeProv) {
        let removestripe = await RemoveStripeSubscription({context: this.context});
        this.setProviderStatus(userId, newStatus,removestripe);
      }
    }else{
    setGlobal(
      'modal',
      confirmModalData({
        confirmMessage: `Are you sure you want to ${statusTitle} ${firstName} ${lastName}?`,
        onConfirm: isConfirmed => {
          if (isConfirmed) {
            setGlobal('modal', {showModal: false});
            this.setProviderStatus(userId, newStatus);
          }
        },
      }),
    );
    }
  };

  setProviderStatus = async (userId, userStatus,subscription=false) => {
    let passData={status: userStatus};
    if(subscription)
    passData.subscription=true
    const response = await updateUserStatus(userId, passData).catch(this.handleError);
    if (response) {
      if(response.message)
      {
        const {setGlobal} = this.context;
        setGlobal('modal', successModalData(response.message));
      }
     
      this.getProviderData();
      await this.updateContextData();
    }
  };

  importProviders = () => {
    this.props.history.push({
      pathname: '/admin/import-provider',
    });
  };
  importProvidersnew = () => {
    this.props.history.push({
      pathname: '/admin/import-provider-new',
    });
  };
  formatedDate = date => {
    return moment.utc(date).format('MM/DD/YYYY hh:mm A');
  };
  render() {
    const title = this.props.name ? this.props.name : 'Active Providers';
    const {list, totalPage, searchText, activePage, isEditProvider, totalRecord} = this.state;
    const activeIndex = activePage - 1;
    // wait for api data
    if (!list) {
      return null;
    }

    // list rows
    let tableOutput = '';

    let listingData = _.map(list, (provider, index) => {
      const {practice = []} = provider;
      return (
        <tr key={provider.id}>
          <td>
            {constants.UserStatus[provider.userStatus]}
            {constants.UserStatus[provider.userStatus] !== 'In Process' && (
              <button
                className={
                  constants.UserStatus[provider.userStatus] === 'Active'
                    ? 'btn-deactivate'
                    : 'btn-edit'
                }
                onClick={() =>
                  this.confirmUpdateStatus(
                    _.get(provider, 'userId', ''),
                    _.get(provider, 'userStatus', ''),
                    _.get(provider, 'firstName', ''),
                    _.get(provider, 'lastName', ''),
                    _.get(provider,'stripeSubscription',undefined)
                  )
                }>
                {constants.UserStatus[provider.userStatus] === 'Active' ? 'Deactivate' : 'Activate'}
              </button>
            )}
          </td>
          {/* <td>
         <span>{provider.birdEyeBusinessId?'Active':'Deactive'}</span> 
        {!provider.birdEyeBusinessId&& provider.userStatus===1&&(
         <button
                className={
                  provider.birdEyeBusinessId?
                     'btn-deactivate'
                    : 'btn-edit'
                }
                onClick={() =>
                  this.deleteBirdEyeAccount(
                    _.get(provider, 'userId', ''),
                    !provider.birdEyeBusinessId?'Active':'Deactive'
                  )
                }>
                Activate
              </button>
              )}
          </td> */}
          <td>
            {_.get(provider, 'role', '') !== 'Staff' && (
              <>
                <button
                  className="btn-edit"
                  onClick={() =>
                    this.ShowEditProvider(
                      _.get(provider, 'provideId', ''),
                      _.get(provider, 'userId', ''),
                    )
                  }>
                  Edit
                </button>
                <button
                  className="btn-edit"
                  onClick={() =>
                    this.ShowProviderReviews(
                      _.get(provider, 'provideId', ''),
                      _.get(provider, 'userId', ''),
                      _.get(provider, 'birdEyeBusinessId', ''),
                    )
                  }>
                  Reviews
                </button>
              </>
            )}
          </td>
          
         
          <td>
            {practice.length > 0 && practice[0].seoPageUrl && (
              <span
                className="link-span"
                onClick={() => window.open(practice[0].seoPageUrl, '_blank')}>
                {`${practice[0].name}`}
              </span>
            )}
            {practice.length > 0 && !practice[0].seoPageUrl && `${practice[0].name}`}
          </td>
          <td className="text-cap">
            {_.get(provider, 'seoPageUrl', '') &&
            provider.suffixes.length > 0 &&
            provider.specialties.length > 0 ? (
              <span
                className="link-span"
                onClick={() => window.open(_.get(provider, 'seoPageUrl', ''), '_blank')}>
                {`${provider.firstName} ${provider.lastName}${getProviderSuffix(
                  provider.suffixes,
                )}`}
              </span>
            ) : (
              `${provider.firstName} ${provider.lastName}${getProviderSuffix(provider.suffixes)}`
            )}
            <ViewDocumentFile
              userId={provider.userId}
              userName={`${provider.firstName} ${provider.lastName}`}
            />
          </td>
          <td>{_.get(provider, 'email', '')}</td>
          <td>{_.get(provider, 'role', '')}</td>
          <td>
            <span className='specialties-span'>
            {/* _.map(_.get(array), return).join() */}
            {_.map(_.get(provider, 'specialties', []), data => {
              return data;
            }).join(', ')}
            {!this.props.name &&(
              <span><img onClick={()=>this.openCustomSpecialityModal(provider)} title='Custom Specialty Titles' className='custom-specialities' src={images.settingGray} /></span>
            )}
            {_.get(provider, 'role', '') === 'Staff' && '-'}
            </span>
          </td>
          <td>{_.get(provider, 'setupStatus', 'Nil')}</td>
                <td>{provider.lastAppointmentDate?this.formatedDate(_.get(provider, 'lastAppointmentDate', '')):'-'}</td>
                <td>{provider.createdAt?this.formatedDate(_.get(provider, 'createdAt', '')):'-'}</td>
                <td>{provider.updatedAt?this.formatedDate(_.get(provider, 'updatedAt', '')):'-'}</td>
                <td>{_.get(provider, 'seoPageUrl', '') &&
            provider.suffixes.length > 0 &&
            provider.specialties.length > 0 ? (
              <span
                className="link-span"
                onClick={() => window.open(_.get(provider, 'seoPageUrl', ''), '_blank')}>
                {`${provider.seoPageUrl}`}
              </span>
            ) :`${provider.seoPageUrl&&provider.seoPageUrl!=='null'?provider.seoPageUrl:'-'}`}</td>
        </tr>
      );
    });
    if (list.length === 0) {
      tableOutput = <div className="no-record">No Records found</div>;
    } else {
      tableOutput = (
        <div className="table-overflow">
          <table className="admin-provider-list">
            <thead>
              <tr>
                <td className="pointer" data-key="status">
                  Status
                  {/* {this.renderShortIcon('status')} */}
                </td>
                {/* <td className="pointer" >
                  Birdeye
                
                </td> */}
                <td>Action</td>
                 <td className="pointer" data-key="name" onClick={this.handleSortingChange}>
                  Practice Name{this.renderShortIcon('name')}
                </td>
                <td className="pointer" data-key="firstName" onClick={this.handleSortingChange}>
                  Provider Name{this.renderShortIcon('firstName')}
                </td>
                <td className="pointer" data-key="email" onClick={this.handleSortingChange}>
                  Email{this.renderShortIcon('email')}
                </td>
                <td className="pointer" data-key="role" onClick={this.handleSortingChange}>
                  Role{this.renderShortIcon('role')}
                </td>
                <td>Specialties</td>
                <td className="pointer" data-key="setupStatus" onClick={this.handleSortingChange}>Setup Status{this.renderShortIcon('setupStatus')}</td>
                <td className="pointer" data-key="lastAppointmentDate" onClick={this.handleSortingChange}>Last Appointment Date (UTC){this.renderShortIcon('lastAppointmentDate')}</td>
                <td className="pointer" data-key="createdAt" onClick={this.handleSortingChange}>CreatedAt (UTC){this.renderShortIcon('createdAt')}</td>
                <td className="pointer" data-key="updatedAt" onClick={this.handleSortingChange}>UpdatedAt (UTC){this.renderShortIcon('updatedAt')}</td>
                <td className="pointer" data-key="seoPageUrl" onClick={this.handleSortingChange}>SEO Page{this.renderShortIcon('seoPageUrl')}</td>
               
              </tr>
            </thead>
            <tbody>{listingData}</tbody>
          </table>
        </div>
      );
    }
    return (
      <Layout>
        <RootContext.Consumer>
          {context => {
            this.context = context;
          }}
        </RootContext.Consumer>
        <AuthContext.Consumer>
        {context => {
         this.authContext=context
        }}
      </AuthContext.Consumer>
        <div className="AdminProviders">
          <SubHeader title={title} hideName />
          <div className="dashboard-panle">
            {!isEditProvider && (
              <>
                <div className="search">
                  {/* <div>
                    <Select
                      options={selectOptions.providerFilterOption}
                      labelIndex="label"
                      valueIndex="value"
                      name="userType"
                      defaultOptionProp={{value: 'all', label: 'All Users'}}
                      isAllowDefaultOpen={true}
                      onChange={this.handleUserTypeChange}
                      value={this.state.searchUserType}
                    />
                  </div> */}
                  {!this.props.name && (
                    <div>
                      <Select
                        options={selectOptions.providerStatusOptions}
                        labelIndex="label"
                        valueIndex="value"
                        name="providerStatus"
                        defaultOptionProp={{value: 'onboardeduser', label: 'All Status'}}
                        isAllowDefaultOpen={true}
                        onChange={this.handleStatusChange}
                        value={this.state.searchStatus}
                      />
                    </div>
                  )}
                  <div>
                    <input
                      placeholder="Search"
                      value={searchText}
                      onChange={this.handleChange}></input>
                    {searchText && (
                      <button className="btn-clear" onClick={this.handleClearSearch}>
                        <img src={images.close} alt="clear" />
                      </button>
                    )}
                  </div>
                  <button onClick={this.handleSearch}>Search</button>
                </div>
                {/* {!this.props.name &&( */}
                {/* <button className="btn-add-new" onClick={this.importProviders}>
                  Import Providers
                </button> */}
                <button  className="btn-add-new" onClick={this.importProvidersnew}>
                  Import Providers
                </button>
              </>
            )}
            <div className="dataCount">
              <span>{totalRecord} providers found.</span>
            </div>
            {!isEditProvider && tableOutput}
            {!isEditProvider && totalPage > 0 && (
              <ReactPaginate
                previousLabel={'<'}
                nextLabel={'>'}
                breakLabel={'...'}
                breakClassName={'break-me'}
                pageCount={totalPage}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={this.handlePageChange}
                containerClassName={'pagination'}
                subContainerClassName={'pages pagination'}
                activeClassName={'active'}
                forcePage={activeIndex}
              />
            )}
          </div>
        </div>
      </Layout>
    );
  }
}

export default ActiveProviders;
